import type { CheckedChangedEventHandler, IconGlyph } from '@sunwebgroup/ui-components'
import { useIntl } from '@/intl'

import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { ChoiceListItem } from '@sunwebgroup/ui-components'

import { equals, isEmpty, reject } from 'ramda'
import * as React from 'react'
import { ShowMore } from '../../../../../../common/components/ShowMore'
import { createSearchFilterClickEvent } from '../../../../domain/analytics'
import { useMultiSelectFilter } from '../../../../domain/hooks'
import FilterGroup from './FilterGroup'

function getIconFromValue(value: string): IconGlyph | undefined {
  if (value === 'adults-only')
    return 'IconTwoPersons'
  if (value === 'CAR_RENTAL_INCLUDED')
    return 'IconCar'
  if (value === 'BUDGET')
    return 'IconPigMoney'
  if (value === 'GROUPS')
    return 'IconGroup'
  if (value === 'FAMILY')
    return 'IconFamily'
  if (value === 'FLY_AND_DRIVE')
    return 'IconCar'
  if (value === 'SHORT_STAY')
    return 'IconClock'
  if (value === 'SMALL_SCALE')
    return 'IconMoodSmileHappy'
  if (value === 'ROMANTIC')
    return 'IconHeartsLoveRomance'
  if (value === 'SPARKY_KIDS_CLUB')
    return 'IconKids'
  if (value === 'SPORTY')
    return 'IconSportsRun'
  if (value === 'CITY_TRIP')
    return 'IconBuilding'
  if (value === 'WELLNESS_AND_SPA')
    return 'IconWellness'
  if (value === 'BRIDGE')
    return 'IconSpade'
  if (value === 'GOLF')
    return 'IconGolfClub'
  if (value === 'SUSTAINABILITY_LABEL')
    return 'IconSustainable'

  return undefined
}

export function VacationTypeFilter() {
  const intl = useIntl()
  const { sendEvent } = useAnalytics()
  const { isFetching, options, selectedValues, setSelection } = useMultiSelectFilter('Themes')
  const selectedValuesLowerCase = selectedValues.map(value => value.toLowerCase())

  const handleFilterChange: CheckedChangedEventHandler = ({ checked, value }) => {
    if (checked) {
      setSelection([...selectedValues, value])
      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: 'themes',
          result: [...selectedValues, value].join(','),
        }),
      )
    }

    if (!checked) {
      setSelection(reject(equals(value), selectedValues))
    }
  }

  if (isEmpty(options))
    return null

  return (
    <FilterGroup title={intl.formatMessage({ id: 'vacation_type_label' })} defaultOpen={selectedValues.length > 0}>
      <ShowMore
        openLabel={intl.formatMessage({ id: 'show_more' })}
        closeLabel={intl.formatMessage({ id: 'show_less' })}
      >
        {options.map(({ name, value, resultsCount }) => (
          <ChoiceListItem
            choiceListItemType="checkbox"
            key={name}
            value={value}
            checked={selectedValuesLowerCase.includes(value.toLowerCase())}
            label={name}
            quantity={resultsCount}
            icon={getIconFromValue(value)}
            onCheckedChange={handleFilterChange}
            disabled={isFetching}
          />
        ))}
      </ShowMore>
    </FilterGroup>
  )
}
